<template>
  <!-- CONTAINER TEMPLATE FOR CONTENT PAGE -->

  <div>
    <div class="nav-space" />
    <Container fix-width class="p-0 lg:p-4 flex flex-wrap lg:flex-no-wrap">
      <div class="w-full lg:w-1/3 mx-0 lg:mr-2">
        <slot name="aside-left" />
      </div>
      <div class="w-full rounded-sm mx-0 lg:mx-3 overflow-hidden">
        <slot name="main-content" />
      </div>
      <div class="w-full lg:w-1/2 px-4 lg:px-0 lg:ml-2">
        <slot name="aside-right" />
      </div>
    </Container>
  </div>
</template>

<script>
import Container from '~/components/layoutelements/Container'

export default {
  components: {
    Container,
  },
}
</script>
